<template>
  <div class="limit-table" style="overflow: hidden">
    <div class="row limit-table" style="overflow: hidden">
      <div class="col-sm">
        <label for="title"> Título </label>
        <h2>
          {{ post.title }}
        </h2>
      </div>
      <div class="col-sm text-right">
        {{ post.created_at }}
      </div>
    </div>
    <hr />
    <div class="text-justify">
      {{ post.body }}
    </div>
    <hr />
    <h5>Comentários ({{ post.comments_count }}):</h5>
    <div v-if="post.comments.length > 0">
      <CommentCard
        v-for="comment in post.comments"
        v-bind:key="comment.id"
        :comment="comment"
        :email="comment.email"
        :content="comment.content"
        :created_at="comment.created_at"
        :likes="comment.likes"
        :dislikes="comment.dislikes"
      />
    </div>
    <div v-else>
      <CommentCard
        :comment="'Sem comentários'"
        :email="'Não há comentários nesta postagem.'"
        :content="''"
        :created_at="''"
        :likes="0"
        :dislikes="0"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import makeToast from '../../../mixins/makeToast';
import CommentCard from '../../../components/Journal/Comment/CommentCard.vue';

export default {
  mixins: [makeToast],
  data: () => ({
    post: {},
  }),
  components: { CommentCard },
  computed: {
    ...mapState(['token', 'dadosUsuario']),
    ...mapGetters('journal', ['setPosts']),
  },
  created() {
    this.getPost();
  },
  props: ['id', 'postId'],
  computed: {
    ...mapState(['token', 'dadosUsuario']),
  },
  methods: {
    ...mapActions('journal', ['getPostByID', 'updatePostByID']),
    getPost() {
      this.getPostByID({
        userId: this.dadosUsuario.id,
        constructionId: this.id,
        postId: this.postId,
      })
        .then((response) => {
          console.log(response);
          this.post = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          this.makeToast(
            'Oopss!',
            'Não foi possivel carregar esta postagem!',
            'danger'
          );
        });
    },
  },
};
</script>

<style scoped>
.border-radius {
  border-radius: 8px;
}

.no-text-decoration:hover {
  color: var(--orange-primary);
  text-decoration: none;
}

.table td,
.table th {
  vertical-align: middle;
}
</style>
